var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-sortby",
    d: "M5.69042 5H0.559591C0.351375 5 0.160393 4.88158 0.0638318 4.69317C-0.0327292 4.50442 -0.0189061 4.27647 0.0996604 4.10166L2.73093 0.220289C2.82466 0.0817766 2.97908 -0.00036335 3.14355 1.43051e-06C3.3082 0.00070858 3.46213 0.0839658 3.5551 0.222843L6.15213 4.10421C6.26947 4.27978 6.2822 4.50666 6.18544 4.69472C6.08854 4.88233 5.89807 5 5.69042 5Z",
    fill: "#A2A6AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortby);
export default __webpack_public_path__ + "static/media/icon-sortby.812a3759a28fe15a311d4a6c3b00768a.svg";
export { ForwardRef as ReactComponent };